import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";

@injectable()
export class DeleteInternalChatUseCase {
  private _repository: InternalChatRepository;

  constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
    this._repository = repository;
  }

  public call(id: string): Promise<void> {
    return this._repository.delete(id);
  }
}
